import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import { theme } from "../../../../utils/global-styles/theme";

const RichTextLink = ({ uri, text }) => {
  const LinkContainer = styled.div`
    margin: 1.25em 0 1.25em 1.25em;
    border-bottom: 4px solid;
    width: max-content;

    a {
      font-family: ${theme.fontFaces.headers};
      font-size: 1.15em;
      font-weight: bold;
      letter-spacing: -0.37px;
      line-height: 1.25em;
    }

    @media only screen and (max-width: ${theme.breakpoints.helper800}) {
      margin-left: 0;
    }
  `;

  return (
    <LinkContainer className="primary-link-container primary-border">
      <a href={uri}>{text.toUpperCase()}</a>
    </LinkContainer>
  );
};

RichTextLink.propTypes = {
  uri: PropTypes.string,
  text: PropTypes.string,
};

export default RichTextLink;
